export default "__VITE_ASSET__Bp6iqBrE__"